import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import PoweredByBrickMe from "@brickme/frontend-common/src/ui/powered-by-brick-me.tsx";
import { useBranding } from "@brickme/d2c-branding/src/browser/context.tsx";
import useAppDispatch from "~/hooks/use-app-dispatch.ts";
import useAppSelector from "~/hooks/use-app-selector.ts";
import { selectUser } from "~/features/user/selectors.ts";
import { signOut } from "~/features/user/store-slice.ts";
import { showLoginPrompt } from "~/features/nav/store-slice.ts";
import MainMenu from "./main-menu.tsx";

function ShortHeader() {
	const user = useAppSelector(selectUser);
	const dispatch = useAppDispatch();
	const t = useTranslator();
	const promptSignIn = () => {
		dispatch(
			showLoginPrompt({
				title: t("Sign in"),
			}),
		);
	};
	const branding = useBranding();

	return (
		<div className="short-header-outer test-nadav">
			<header className="short-header">
				<div className="short-header__container container-fluid">
					<div className="short-header__content">
						<div className="short-header__aside">
							<MainMenu />
						</div>
						<div className="short-header__logo">
							<a href="/" className="short-header__logo-link">
								<img
									src={branding.logoSquareSvg}
									className="short-header__logo-img js-svg"
									alt={t("{companyName} Creator", {
										companyName: branding.companyName,
									})}
								/>
								{branding.showPoweredBy && <PoweredByBrickMe />}
							</a>
						</div>
						{user.type === "guest" && (
							<div className="short-header__logout logout">
								<span className="logout__text">{t("Guest")}</span>{" "}
								<button
									type="button"
									className="logout__link"
									onClick={promptSignIn}
								>
									(<span className="logout__link-inner">{t("Sign in")}</span>)
								</button>
							</div>
						)}
						{user.type === "signedIn" && (
							<div className="short-header__logout logout">
								<span className="logout__text">
									{t("G'day {firstName}!", {
										firstName: user.user.firstName ?? "there",
									})}
								</span>{" "}
								<button
									type="button"
									className="logout__link"
									onClick={() => dispatch(signOut())}
								>
									(<span className="logout__link-inner">{t("Logout")}</span>)
								</button>
							</div>
						)}
					</div>
				</div>
			</header>
		</div>
	);
}

export default ShortHeader;
